import { api } from "../../../../../services/api";

export async function getUF() {
  const UF = await api.get("/getUf");
  return UF.data.recordset;
}
